<template>
  <div class="nights-flight-details-modal-component">
    <v-card class="border-none">
      <v-card-text class="no-padding-card">
        <pack-flights-wrapper></pack-flights-wrapper>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { NIGHTS_SET_FLIGHT } from "../../../store/nights/mutation-types";
import SingleFlightInfo from "./SingleFlightInfo.vue";
import PackFlightJourney from "./PackFlightJourney.vue";
import PackFlightsWrapper from "./PackFlightsWrapper.vue";
import { ucfirst } from '../../../utils/strings';
import moment from "../../../plugins/moment";

export default {
  components: { SingleFlightInfo, PackFlightJourney, PackFlightsWrapper },
  data() {
    return {
      dialog: false,
      ucfirst,
      showAllFlights: false

    };
  },
  computed: {
    destination() {
      return this.$store.state.nights.destination.name;
    },
    flights() {
      return this.$store.state.nights.resources.flights;
    },
    internalflights() {
      return this.$store.state.nights.resources.internFlights;
    },
    loading() {
      return this.$store.state.nights.loading;
    },

  },
  methods: {
    tz(flight) {
      console.log(flight);
      return moment.tz(flight.journeyFlightDepartureTime, "YYYY-MM-DDTHH:mm:ss", 'Europe/Madrid')
    },
    flightIsSelected(flightId) {
      return this.$store.state.nights.flight.id === flightId;
    },
    getPriceDifference(flightPrice) {
      const currentFlightPrice = this.$store.state.nights.flight.price;
      return Number((flightPrice - currentFlightPrice).toFixed(2));
    },
    selectFlight(flight) {
      this.dialog = false;
      this.$store.commit(NIGHTS_SET_FLIGHT, _.cloneDeep(flight));
    },
    showMoreDetails() {
      this.showAllFlights = true;
    },
    hideMoreDetails() {
    this.showAllFlights = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.nights-flight-details-modal-component::v-deep {
  .v-dialog__content {
    z-index: 2001 !important;
  }

   //Scrollbar customized
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #00adbc;
  }

  .v-card.theme--light {
      box-shadow: none !important;
      background-color: transparent !important;
    }
    .v-sheet.theme--light {
      box-shadow: none !important;
    }
  .v-dialog {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 !important;
    max-height: none !important;
    @media (min-width: 1280px) {
      width: 760px !important;
      height: auto !important;
      max-height: 90% !important;
    }

    .flights-container {
      height: 100%;
      overflow-y: scroll;
      .flight.hoverable:hover {
        -webkit-box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
        box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
      }
      @media (min-width: 1280px) {
        overflow-y: auto;
      }
    }
  }
}

.modal-content-container {
  max-width: 725px;
  margin: auto;
}

.v-card__title {
  font-size: 25px !important;
  font-weight: 900;
  @media (min-width: 1024px) {
    font-size: 35px !important;
  }
}

.mdi-close::before {
  @media (min-width: 1024px) {
    font-size: 2.75rem;
  }
}

.v-card {
  @media (min-width: 1024px) {
    max-width: 740px;
  }
  .v-sheet {
    .theme--light {
      box-shadow: none !important;
    }
  }
}

.change-flights-btn {
  margin-top: 0 !important;
  background: $turquoiseBlue !important;
  width: 110px !important;
  height: 54px !important;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  box-shadow: unset !important;

  &.disabled {
    pointer-events: none;
  }
}

.flight {
  border-radius: 15px;
  border: solid 1px #979797;
  padding: 20px 14px;

  @media (min-width: 1024px) {
    padding: 25px;
  }

  &.selected {
    border: 2px solid $turquoiseBlue;
  }

  + .flight {
    margin-top: 1.25rem;

    @media (min-width: 1024px) {
      margin-top: 1.5rem;
    }
  }

  > div:first-child {
    border-bottom: 2px solid #000e32;
    padding-bottom: 1.5rem;

    @media (min-width: 1024px) {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  > div:last-child {
    padding-top: 1.5rem;

    @media (min-width: 1024px) {
      padding-top: 0;
      align-self: center;
    }
  }

  .current,
  .select-flight {
    font-weight: 900;
    line-height: 1.63;
  }

  .current {
    color: #0035bf;
    font-size: 16px;
  }

  .select-flight {
    color: $turquoiseBlue;
  }

  .price {
    color: black;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.08;
  }
}

.btn-see-more {
  font-size: 20px;
}

.no-padding-card{
  padding: 0 !important;
}
</style>
